import React from 'react'
import clsx from 'classnames'
import { useNavigate } from 'react-router'
import type { ClubPage as ClubPageData } from 'api/api.types'
import uselessImage from 'assets/useless.jpg'
import { parseHtml } from 'utils/htmlParserWithCustomLinks'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { AppLink } from 'components/Utility/AppLink/AppLink'
import styles from './ClubPage.module.scss'

const LOYALTY_RULES_URL = 'https://palchiki.com/static/loyalty.pdf'

type ClubPageProps = {
  page: ClubPageData,
}

/** The «Клуб Пальчики» loyalty programme page */
export const ClubPage: React.FC<ClubPageProps> = ({ page }) => {
  const vars = page.templateVars.pageVars
  const navigate = useNavigate()
  const levels = [
    { level: vars.level1, className: styles.level1 },
    { level: vars.level2, className: styles.level2 },
    { level: vars.level3, className: styles.level3 },
  ]

  return (
    <div className={styles.root}>
      <div>
        <h1 className={styles.title}>{page.title}</h1>
        <h3 className={styles.subtitle}>{vars.subtitle}</h3>
      </div>
      <div className={styles.bg}>
        <img src={uselessImage} alt={'Фон'} />
      </div>
      <div className={styles.delimiter}>
        <span className={styles.delimiterText}>Всё просто!</span>
      </div>
      <div className={styles.content}>
        <div className={styles.levels}>
          {levels.map(({ level, className }, index) => (
            <div key={index} className={clsx([className, styles.level])}>
              <div className={styles.levelTitle}>{level.title}</div>
              <div className={clsx([styles.levelDescription, 'text-content'])}>{parseHtml(level.description)}</div>
            </div>
          ))}
        </div>
        <div className={styles.additionalInfo}>
          <div className={styles.blueList}>
            <div className={styles.blueListContent}>
              <div className={styles.blueListTitle}>
                {vars.blueList.title}
              </div>
              <div className={clsx([styles.blueListText, 'text-content'])}>
                {parseHtml(vars.blueList.text)}
              </div>
            </div>
          </div>
          {vars.info.map((item, i) => (
            <div key={i} className={styles.infoBlock}>
              <div className={styles.infoIcon}>
                <img
                  src={item.icon?.image?.[0]?.path}
                  alt={item.icon?.type === 'image' ? item.icon.imageAlt : undefined}
                />
              </div>
              <div className={clsx([styles.infoText, 'text-content'])}>
                {parseHtml(item.description)}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.action}>
        <div className={styles.joinText}>
          <span>Присоединяйтесь <br />к «Клубу&nbsp;Пальчики»!</span>
        </div>
        <div className={styles.arrow} />
        <div className={styles.buttonContainer}>
          <AppButton shadowColor={'blue'} onClick={() => navigate('#profile')}>
            Вступить в клуб
          </AppButton>
        </div>
        <div className={styles.link}>
          <AppLink path={LOYALTY_RULES_URL}>
            Полные правила программы лояльности «Клуб Пальчики»
          </AppLink>
        </div>
      </div>
    </div>
  )
}
